import _ from 'underscore'
import op from 'object-path'

import actions from '../action/order'
import CONSTANT from '../constant/order'

const orderList = {
  list:[],
  total: 0
}
const orderDetail = {}
// const cancelStatus = -2;
// const confirmDeliveryStatus = null
const recommendProduct = {
  list: [],
  total: 0
}

const invoiceInfo = {
  invoiceType: 1,
  buyerType: 1,
  buyerName: "",
  taxNum: "",
  phone: "",
  email: "",
}

const productByOrderId = []
const deliveryInfo = {}
const orderDetailOld = {}

const deleteOrderStatus = null
export default {
  actions,
  state: {
    orderList,
    orderDetail,
    // cancelStatus,
    // confirmDeliveryStatus
    recommendProduct,
    productByOrderId,
    deliveryInfo,
    orderDetailOld,
    invoiceInfo,
    invoiceList: [],
    invoiceDetail: {},
    deleteOrderStatus,
  },
  mutations: {
    [CONSTANT.ORDER_GET_ALL_SUCCESS] (state, data) {
      state.orderList.list = data.list
      state.orderList.total = data.page.total
      return state
    },
    [CONSTANT.ORDER_GET_ALL_ERROR] (state, data) {
      state.orderList.list = []
      state.orderList.total = 0
      return
    },
    [CONSTANT.ORDER_GET_ALL_EMPTY] (state) {
      state.orderList.list = []
      state.orderList.total = 0
      return state
    },

    [CONSTANT.ORDER_GET_DETAIL_SUCCESS] (state, data) {
      state.orderDetail = data
      return state
    },
    [CONSTANT.ORDER_GET_DETAIL_ERROR] (state, data) {
      state.orderDetail = {}
      return state
    },

    // [CONSTANT.ORDER_GET_ALL_MORE_EMPTY] (state) {
    //   return state.orderList = { total: 0, list: []}
    // },
    [CONSTANT.ORDER_GET_ALL_MORE_SUCCESS] (state, result) {
      state.orderList = { total: result.page.total, list: [...state.orderList.list, ...result.list]}
    },
    // [CONSTANT.ORDER_GET_ALL_MORE_ERROR] (state, e) {
    //   return state.orderList = { total: 0, list: []}
    // },
    // 旧商城订单详情
    [CONSTANT.ORDER_OLD_GET_DETAIL_SUCCESS] (state, data) {
      state.orderDetailOld = data
      return state
    },
    [CONSTANT.ORDER_OLD_GET_DETAIL_ERROR] (state, data) {
      state.orderDetailOld = {}
      return state
    },
    // 取消下单
    [CONSTANT.ORDER_CANCEL_SUCCESS] (state, e) {
      state.cancelStatus = e
      return state
    },
    [CONSTANT.ORDER_CANCEL_ERROR] (state, e) {
      state.cancelStatus = e
      return state
    },
    // 确认收货
    [CONSTANT.DELIVERY_GET_CONFIRM_SUCCESS] (state, data) {
      return state.confirmDeliveryStatus = data
    },
    [CONSTANT.DELIVERY_GET_CONFIRM_ERROR] (state, e) {
      return state.confirmDeliveryStatus = null
    },
    // 热门推荐
    [CONSTANT.ORDER_GET_RECOMMEND_LIST_SUCCESS] (state, data) {
      state.recommendProduct.list = data.data.list
      state.recommendProduct.total = data.data.page.total
      return state
    },
    [CONSTANT.ORDER_GET_RECOMMEND_LIST_ERROR] (state, data) {
      state.recommendProduct.list =[]
      state.recommendProduct.total = 0
      return state
    },
    [CONSTANT.ORDER_GET_RECOMMEND_LIST_EMPTY] (state) {
      state.recommendProduct.list = []
      state.recommendProduct.total = 0
      return state
    },
    // 检查SKU是否下架
    [CONSTANT.ORDER_CHECK_PRODUCT_STATUS_SUCCESS] (state, data) {
      state.productByOrderId = data
      return state
    },
    [CONSTANT.ORDER_CHECK_PRODUCT_STATUS_ERROR] (state, data) {
      state.productByOrderId = []
      return state
    },
    // 查看物流
    [CONSTANT.ORDER_GET_DELIVERY_SUCCESS] (state, data) {
      state.deliveryInfo = data
      return state
    },
    [CONSTANT.ORDER_GET_DELIVERY_ERROR] (state, data) {
      state.deliveryInfo = {}
      return state
    },
    [CONSTANT.ORDER_GETORDERSIMPLE_SUCCESS] (state, data) {
      return state
    },
    [CONSTANT.ORDER_GETORDERSIMPLE_ERROR] (state, data) {
      return state
    },
    [CONSTANT.ORDER_GET_USERINVOICE_SUCCESS] (state, data) {
      state.invoiceList = data.list
      return state
    },
    [CONSTANT.ORDER_GET_USERINVOICE_ERROR] (state, data) {
      return state
    },
    [CONSTANT.ORDER_SET_ORDERINVOICE_SUCCESS] (state, data) {
      state.invoiceInfo = data
      return state
    },
    [CONSTANT.ORDER_SET_ORDERINVOICE_ERROR] (state, data) {
      return state
    },
    [CONSTANT.ORDER_GET_ORDER_INVOICE_DETAIL_SUCCESS] (state, data) {
      state.invoiceDetail = data
      return state
    },
    [CONSTANT.ORDER_GET_ORDER_INVOICE_DETAIL_ERROR] (state, data) {
      return state
    },
    [CONSTANT.ORDER_DELETE_SUCCESS](state, data){
      state.deleteOrderStatus = data
      return state
    },
    //刷新状态
    refreshStatusForDetail(state, data) {
      if(data.routeType == 1) {
        state.orderDetail.orderStatus = data.orderStatus
      }
    },
    //刷新状态for列表
    refreshStatusForList(state, data) {
      for(let i of op(state).get('orderList.list')) {
        if(i.orderId == data.orderId) {
          i.orderStatus = data.orderStatus
          break
        }
      }
    }

  },
  getters: {
    [CONSTANT.ORDER_GETTER_GET_ORDER_ACTIVE_INFO] (state) {
      const activeInfo = state.orderDetail.activeInfo || ''
      const orderStatus = state.orderDetail.orderStatus
      if (state.orderDetail.orderType === CONSTANT.ORDER_TYPE_IS_GROUP  && !_.isEmpty(activeInfo)) {
        return activeInfo
      }
      return ''
    },
    [CONSTANT.ORDER_GETTER_DETAIL] (state, getters, rootState) {
      return state.orderDetail
    },
    [CONSTANT.ORDER_GETTER_RECOMMEND_LIST] (state, getters, rootState) {
      return state.recommendProduct
    },
    [CONSTANT.ORDER_GETTER_PRODUCT_STATUS_LIST] (state, getters, rootState) {
      return state.productByOrderId
    },
  }
}
